import { List as ImmutableList, Record, type RecordOf } from 'immutable';

export const POSTPONED_ACTIONS_REDUCER_KEY = 'postponedActionsStore';

export type PostponableActionMeta = object;

export type PostponableAction = {
  type: string;
  meta?: PostponableActionMeta | null;
};

export const getPostponableActionAttemptsLeft = (action: PostponableAction): number | undefined => {
  const { meta } = action;
  if (!meta || !('attemptsLeft' in meta)) {
    return undefined;
  }
  return typeof meta.attemptsLeft === 'number' ? meta.attemptsLeft : undefined;
};

export const setPostponableActionAttemptsLeft = (action: PostponableAction, attemptsLeft: number): void => {
  action.meta = action.meta || {};
  Object.assign(action.meta, { attemptsLeft });
};

export type PostponedActionFailure = () => unknown;

export type PostponedActionProps = {
  key?: string;
  action: PostponableAction | null;
  onFailure?: PostponedActionFailure;
  maxAttempts?: number;
  error?: unknown;
};

export type PostponedAction = RecordOf<PostponedActionProps>;
export type PostponedActions = ImmutableList<PostponedAction>;

export type PostponedActionsStoreProps = {
  postponedActions: PostponedActions;
};

export type PostponedActionsStore = RecordOf<PostponedActionsStoreProps>;

export type AddPostponedActionPayload = Omit<PostponedActionProps, 'key'> & {
  action: PostponableAction;
};

export const mkPostponedActionsStore = Record<PostponedActionsStoreProps>({
  postponedActions: ImmutableList<PostponedAction>(),
});

export const mkPostponedAction = Record<PostponedActionProps>({
  key: undefined,
  action: null,
  onFailure: undefined,
  maxAttempts: undefined,
  error: undefined,
});

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [POSTPONED_ACTIONS_REDUCER_KEY]: PostponedActionsStore;
  }
}
